<template>
  <div :class="icon()"></div>
</template>

<script>
var moment = require("moment");

export default {
  name: "UpDown",
  props: {
    data: Array
  },
  computed: {
    /* getOnlineData() {
      var data = JSON.parse(JSON.stringify(this.data));

      if (data.length > 0) {
        for (var i = 0; i < 23 - moment().format("HH"); i++) {
          data.unshift(data.pop());
        }
      }

      return data;
    } */
  },
  methods: {
    icon() {
      var trend_ = (data_array => {
        var saida = 0;

        var a = data_array[data_array.length - 3] || 0;
        var b = data_array[data_array.length - 2] || 0;
        var c = data_array[data_array.length - 1] || 0;
        var isPositive = b > a;
        var hasTrend = (c - b) * (b - a) > 0;

        if (isPositive && hasTrend) saida = 1;
        else if (!isPositive && hasTrend) saida = -1;
        else saida = 0;

        return saida;
      })(this.data);

      var trend = "";

      if (trend_ > 0) trend = "arrow_upward";
      else if (trend_ < 0) trend = "arrow_downward";

      return trend;
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed|Titillium+Web");

div.root {
  padding: 0;
  margin: 2px;
  width: 100%;
  height: 140px;
  background-color: #ffffff;
  display: inline-block;
}

div.box-title {
  width: 112px;
  height: 25px;
  font-family: "Roboto Condensed", "Arial Narrow";
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
}

div.box-value {
  margin-bottom: 2px;
  font-family: "Titillium Web", "Arial";
  font-size: 36px;
  font-weight: bold;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: black;
}

div.box-icon {
  width: 36px !important;
  height: 36px !important;
}
.arrow_upward {
  margin-top: 12px;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 0 8px 14px 8px;
  border-color: transparent transparent #1eeb2e transparent;
}

.arrow_downward {
  transform: rotate(180deg);
  margin-top: 12px;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 0 8px 14px 8px;
  border-color: transparent transparent #eb1e36 transparent;
}

.diamond {
  /* margin-top: 12px;
  transform: rotate(45deg);
  width: 16px;
  height: 16px;
  background-color: #15d3eb; */
}

div.box-footer {
  width: 146px;
  height: 20px;
  font-family: Arial;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
}
div.small {
  font-size: x-small;
}

div.circle {
  background: #1eeb2e;
  display: inline-block;
  margin: 0 0 2px 0;
  border-radius: 50%;
  height: 12px;
  width: 12px;
}

.bg-light {
  font-weight: 300;
  text-transform: uppercase;
  font-size: x-small;
}
</style>





// WEBPACK FOOTER //
// src/components/charts/UpDown.vue